import account from "../../assets/icons/account.svg";
import security from "../../assets/icons/security.svg";
import { getDecodedAccessToken } from "../../utils";

const userToken = getDecodedAccessToken();

export const accountInfoData = [
  {
    title: "Personal information",
    type: "Email",
    icon: account,
    value: userToken ? userToken.email ?? "No email" : "No email",
    change: "Change Email",
  },
  {
    title: "Security",
    type: "Password",
    icon: security,
    value: "******************",
    change: "Change Password",
  },
];

export const accountSubData = [
  {
    subNumber: "20264351",
    renewalDate: "04/04/2024",
    invoiceDate: "23/03/2023",
    price: "$45.00",
    email: userToken ? userToken.email ?? "No email" : "No email",
    method: "**1234",
    expired: false,
    trial: true,
  },
];
